import { LuxDt } from "./Date1TimeF.mts";
let overrideLuxonNow = (undefined
// LuxDt.fromISO('2025-12-02T13:30:06.786Z')
);
export const luxNow = () => {
    // dont override here, use overrideLuxonNow
    return (overrideLuxonNow || LuxDt.local());
};
export const luxUtcNow = () => luxNow().setZone('utc');
export const elapsedSec = (startTime) => Math.round((Date.now() - startTime) / 1000);
